import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ConfirmButton from '../ConfirmButton';
import { isReactivableStatus, isCancellableStatus } from '../../helpers/subscription';
import { FormattedMessage } from 'react-intl';

/**
 * Button to resume or pause a subscription
 * Displays nothing if the subscription is neither pausable or resumable (trial)
 */
class SubscriptionPauseResume extends Component {
  render() {
    const {
      subscription,
      handleCancel,
      handleReactivate,
      handlePaymentInfo,
    } = this.props;

    const isCancelled = isReactivableStatus(subscription.status);
    const isCancellable = isCancellableStatus(subscription.status);
    const hasPaymentInfo = subscription.hasPaymentInfo;
    const isFreemiumPlan = subscription.plan.isFree;

    //
    return (
      isCancelled 
        ? (hasPaymentInfo || isFreemiumPlan)
          ? <ConfirmButton 
              title={<FormattedMessage id="subscription.confirmation.resume.title" />}
              message={<FormattedMessage id="subscription.confirmation.resume" values={{product: subscription.plan.product.name}} />}
              working={subscription.reactivating}
              onClick={_ => handleReactivate({ subscription })}
            >  
              <FormattedMessage id='subscription.button.resume' />
            </ConfirmButton>
          : <ConfirmButton 
              message={<FormattedMessage id="subscription.confirmation.chargify.redirection" />}
              working={subscription.reactivating}
              onClick={_ => handlePaymentInfo({ subscription })}
            >  
              <FormattedMessage id='subscription.button.resume' />
            </ConfirmButton>
        : isCancellable && <ConfirmButton 
          cancel={true}
          working={subscription.cancelling}
          onClick={_ => handleCancel({ subscription })}
          title={<FormattedMessage id="subscription.confirmation.pause.title" />}
          message={<FormattedMessage id="subscription.confirmation.pause" values={{product: subscription.plan.product.name}} />}
        >
          <FormattedMessage id='subscription.button.pause' />
        </ConfirmButton>
    )

  }
}

SubscriptionPauseResume.propTypes = {
  subscription: PropTypes.object.isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleReactivate: PropTypes.func.isRequired,
}

export default SubscriptionPauseResume


// WEBPACK FOOTER //
// ./src/components/subscriptions/SubscriptionPauseResume.js